/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import Typography from './Typography';

import styles from '../../styles/typography/section-title.module.css';

const propTypes = {
    tag: PropTypes.string,
    brand: PropTypes.string,
    colored: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    tag: 'h4',
    brand: null,
    colored: null,
    className: null,
};

function SectionTitle({ tag, brand, colored, className, ...props }) {
    return (
        <Typography
            tag={tag}
            className={classNames([
                styles.container,
                {
                    [styles.colored]: colored,
                },
                className,
            ])}
            data-brand={brand}
            {...props}
        />
    );
}

SectionTitle.propTypes = propTypes;
SectionTitle.defaultProps = defaultProps;

export default SectionTitle;
